import { z } from 'zod';
/** Prisma `cuid()` identifiers — validated as non-empty opaque strings. */
export const idSchema = z.string().min(1, 'Brak identyfikatora');
/**
 * Money as a plain number with at most two decimals.
 *
 * Amounts are stored as `Decimal(14,2)` in Postgres and only converted to
 * `number` at the API boundary, where the range is far inside `Number.MAX_SAFE_INTEGER`.
 */
export const moneySchema = z
    .number()
    .finite()
    // `Math.round` always yields an integer, so the obvious-looking
    // `Number.isInteger(Math.round(v * 100))` is a no-op that accepts 1,23456
    // and lets Postgres silently round it away. Compare against the rounding
    // instead, with an epsilon for binary-float representation.
    .refine((value) => Math.abs(value * 100 - Math.round(value * 100)) < 1e-6, {
    message: 'Kwota może mieć najwyżej dwa miejsca po przecinku',
});
export const nonNegativeMoneySchema = moneySchema.min(0, 'Kwota nie może być ujemna');
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
export const sortDirectionSchema = z.enum(['asc', 'desc']).default('desc');
/**
 * Boolean that survives a query string.
 *
 * `z.coerce.boolean()` is `Boolean(input)`, and `Boolean("false") === true` —
 * so a filter sent as `?includeInactive=false` would switch itself on. This
 * parses the wire representation instead of coercing it.
 */
export function booleanQuery(defaultValue = false) {
    return z
        .union([z.boolean(), z.string()])
        .optional()
        .transform((value) => {
        if (value === undefined || value === '')
            return defaultValue;
        if (typeof value === 'boolean')
            return value;
        return value === 'true' || value === '1';
    });
}
/** Accepts both `Date` objects and ISO strings, so the same schema works on both sides. */
export const dateSchema = z.coerce.date();
export const optionalDateSchema = z.coerce.date().nullish();
//# sourceMappingURL=common.schema.js.map